import type { ReactNode } from 'react';
import { MascotWatermark } from './Watermark';
import { Wave } from './Wave';
import { BackIcon } from './icons';

/** Синяя шапка ANTÉ — каркас всех «внутренних» экранов.
 *  Волна по умолчанию включена (Главная вместо неё использует «шторку»,
 *  Live-обзор — вообще без волны). Маскот — водяной знак с вылетом за край. */
export function BlueHeader({
  children,
  wave = true,
  mascot,
  className,
}: {
  children: ReactNode;
  wave?: boolean;
  mascot?: 'tr' | 'br' | 'bl';
  className?: string;
}) {
  return (
    <header className={`bhead${className ? ` ${className}` : ''}`}>
      {mascot && <MascotWatermark pos={mascot} />}
      {children}
      {wave && <Wave />}
    </header>
  );
}

/** Круглая кнопка «назад» для синей шапки. */
export function HeaderBack({ onClick }: { onClick: () => void }) {
  return (
    <button className="hbtn" onClick={onClick} aria-label="Назад">
      <BackIcon />
    </button>
  );
}
